module.exports = __webpack_public_path__ + "img/vol06_character_thumb03.47ddc92b.png";